import Component from '../core/Component'
import { queryAll } from '../utils/dom'

export const defaults = {
    behavior: 'uncheck' // check, uncheck, keep-checked
}

export default class CheckboxGroup extends Component {

    constructor(element) {
        super(element, defaults)

        this.ref = {
            master: null
        }

        if (this.element.dataset.componentBehavior) {
            this.options.behavior = this.element.dataset.componentBehavior
        }
    }

    prepare() {
        this.element.addEventListener('change', ::this.handleChange)
    }

    handleChange(event) {

        if (this.options.behavior === 'uncheck') {
            if (this.ref.master === event.target) {
                const checked = queryAll('input[type="checkbox"]:checked', this.element)
                    .filter(element => element !== this.ref.master)

                if (checked.length === 0 && !this.ref.master.checked) {
                    this.ref.master.checked = true
                }

                if (this.ref.master.checked) {
                    checked.forEach(element => element.checked = false)
                }

            } else {
                if (this.ref.master.checked) {
                    this.ref.master.checked = false
                }
            }
        }

        if (this.options.behavior === 'check') {
            const checkboxes = queryAll('input[type="checkbox"]', this.element)
                .filter(checkbox => checkbox !== this.ref.master)

            if (this.ref.master === event.target) {
                checkboxes.forEach(checkbox => checkbox.checked = this.ref.master.checked)
            } else {
                const checked = checkboxes.filter(checkbox => checkbox.checked)
                this.ref.master.checked = checked.length === checkboxes.length
            }
        }

        if (this.options.behavior === 'keep-checked') {
            const checkboxes = queryAll('input[type="checkbox"]', this.element)
                .filter(checkbox => checkbox !== this.ref.master)

            if (this.ref.master === event.target) {
                checkboxes.forEach(checkbox => checkbox.checked = this.ref.master.checked)
            } else {
                const checked = checkboxes.filter(checkbox => checkbox.checked)
                this.ref.master.checked = checked.length > 0
            }
        }
    }
}